export const currencyOptions = [
  { value: 1, label: 'Рубль РФ' },
  { value: 2, label: 'Доллар США' },
  { value: 3, label: 'Евро' },
  { value: 4, label: 'Тенге' },
  { value: 5, label: 'Гривна' },
  { value: 6, label: 'Беларусский рубль' },
];

export const timezoneOptions = [
  { value: '1', label: '(UTC-12:00) Линия перемены дат' },
  { value: '2', label: '(UTC-11:00) Время в формате UTC -11' },
  { value: '3', label: '(UTC-10:00) Алеутские острова' },
  { value: '4', label: '(UTC-10:00) Гавайи' },
  { value: '5', label: '(UTC-09:30) Маркизские острова' },
  { value: '6', label: '(UTC-09:00) Аляска' },
  { value: '7', label: '(UTC-09:00) Время в формате UTC -09' },
  { value: '8', label: '(UTC-08:00) Время в формате UTC -08' },
  { value: '9', label: '(UTC-08:00) Нижняя Калифорния' },
  { value: '10', label: '(UTC-08:00) Тихоокеанское время США и Канада' },
  { value: '11', label: '(UTC-07:00) Аризона' },
  { value: '12', label: '(UTC-07:00) Горное время США и Канада' },
  { value: '13', label: '(UTC-07:00) Ла-Пас, Мазатлан, Чихуахуа' },
  { value: '14', label: '(UTC-07:00) Юкон' },
  { value: '15', label: '(UTC-06:00) Гвадалахара, Мехико, Монтеррей' },
  { value: '16', label: '(UTC-06:00) о. Пасхи' },
  { value: '17', label: '(UTC-06:00) Саскачеван' },
  { value: '18', label: '(UTC-06:00) Центральная Америка' },
  { value: '19', label: '(UTC-06:00) Центральное время США и Канада' },
  { value: '20', label: '(UTC-05:00) Богота, Кито, Лима, Рио-Бранко' },
  { value: '21', label: '(UTC-05:00) Восточное время США и Канада' },
  { value: '22', label: '(UTC-05:00) Гавана' },
  { value: '23', label: '(UTC-05:00) Гаити' },
  { value: '24', label: '(UTC-05:00) Индиана восток' },
  { value: '25', label: '(UTC-05:00) Острова Теркс и Кайкос' },
  { value: '26', label: '(UTC-05:00) Четумаль' },
  { value: '27', label: '(UTC-04:00) Асунсьон' },
  { value: '28', label: '(UTC-04:00) Атлантическое время Канада' },
  { value: '29', label: '(UTC-04:00) Джорджтаун, Ла-Пас, Манаус, Сан-Хуан' },
  { value: '30', label: '(UTC-04:00) Каракас' },
  { value: '31', label: '(UTC-04:00) Куяба' },
  { value: '32', label: '(UTC-04:00) Сантьяго' },
  { value: '33', label: '(UTC-03:30) Ньюфаундленд' },
  { value: '34', label: '(UTC-03:00) Арагуаяна' },
  { value: '35', label: '(UTC-03:00) Бразилия' },
  { value: '36', label: '(UTC-03:00) Буэнос-Айрес' },
  { value: '37', label: '(UTC-03:00) Гренландия' },
  { value: '38', label: '(UTC-03:00) Кайенна, Форталеза' },
  { value: '39', label: '(UTC-03:00) Монтевидео' },
  { value: '40', label: '(UTC-03:00) Пунта-Аренас' },
  { value: '41', label: '(UTC-03:00) Сальвадор' },
  { value: '42', label: '(UTC-03:00) Сен-Пьер и Микелон' },
  { value: '43', label: '(UTC-02:00) Время в формате UTC -02' },
  { value: '44', label: '(UTC-01:00) Азорские о-ва' },
  { value: '45', label: '(UTC-01:00) Кабо-Верде' },
  { value: '46', label: '(UTC+00:00) Дублин, Эдинбург, Лиссабон, Лондон' },
  { value: '47', label: '(UTC+00:00) Монровия, Рейкьявик' },
  { value: '48', label: '(UTC+00:00) Сан-Томе' },
  { value: '49', label: '(UTC+01:00) Касабланка' },
  {
    value: '50',
    label: '(UTC+01:00) Амстердам, Берлин, Берн, Вена, Рим, Стокгольм',
  },
  {
    value: '51',
    label: '(UTC+01:00) Белград, Братислава, Будапешт, Любляна, Прага',
  },
  { value: '52', label: '(UTC+01:00) Брюссель, Копенгаген, Мадрид, Париж' },
  { value: '53', label: '(UTC+01:00) Варшава, Загреб, Сараево, Скопье' },
  { value: '54', label: '(UTC+01:00) Западная Центральная Африка' },
  { value: '55', label: '(UTC+02:00) Амман' },
  { value: '56', label: '(UTC+02:00) Афины, Бухарест' },
  { value: '57', label: '(UTC+02:00) Бейрут' },
  {
    value: '58',
    label: '(UTC+02:00) Вильнюс, Киев, Рига, София, Таллин, Хельсинки',
  },
  { value: '59', label: '(UTC+02:00) Виндхук' },
  { value: '60', label: '(UTC+02:00) Дамаск' },
  { value: '61', label: '(UTC+02:00) Джуба' },
  { value: '62', label: '(UTC+02:00) Иерусалим' },
  { value: '63', label: '(UTC+02:00) Каир' },
  { value: '64', label: '(UTC+02:00) Калининград' },
  { value: '65', label: '(UTC+02:00) Кишинев' },
  { value: '66', label: '(UTC+02:00) Сектор Газа, Хеврон' },
  { value: '67', label: '(UTC+02:00) Триполи' },
  { value: '68', label: '(UTC+02:00) Хараре, Претория' },
  { value: '69', label: '(UTC+02:00) Хартум' },
  { value: '70', label: '(UTC+03:00) Багдад' },
  { value: '71', label: '(UTC+03:00) Волгоград' },
  { value: '72', label: '(UTC+03:00) Кувейт, Эр-Рияд' },
  { value: '73', label: '(UTC+03:00) Минск' },
  { value: '74', label: '(UTC+03:00) Москва, Санкт-Петербург' },
  { value: '75', label: '(UTC+03:00) Найроби' },
  { value: '76', label: '(UTC+03:00) Стамбул' },
  { value: '77', label: '(UTC+03:30) Тегеран' },
  { value: '78', label: '(UTC+04:00) Абу-Даби, Мускат' },
  { value: '79', label: '(UTC+04:00) Астрахань, Ульяновск' },
  { value: '80', label: '(UTC+04:00) Баку' },
  { value: '81', label: '(UTC+04:00) Ереван' },
  { value: '82', label: '(UTC+04:00) Ижевск, Самара' },
  { value: '83', label: '(UTC+04:00) Порт-Луи' },
  { value: '84', label: '(UTC+04:00) Саратов' },
  { value: '85', label: '(UTC+04:00) Тбилиси' },
  { value: '86', label: '(UTC+04:30) Кабул' },
  { value: '87', label: '(UTC+05:00) Ашхабад, Ташкент' },
  { value: '88', label: '(UTC+05:00) Екатеринбург' },
  { value: '89', label: '(UTC+05:00) Исламабад, Карачи' },
  { value: '90', label: '(UTC+05:00) Кызылорда' },
  { value: '91', label: '(UTC+05:30) Колката, Мумбаи, Нью-Дели, Ченнай' },
  { value: '92', label: '(UTC+05:30) Шри-Джаявардене-пура-Котте' },
  { value: '93', label: '(UTC+05:45) Катманду' },
  { value: '94', label: '(UTC+06:00) Астана' },
  { value: '95', label: '(UTC+06:00) Дакка' },
  { value: '96', label: '(UTC+06:00) Омск' },
  { value: '97', label: '(UTC+06:30) Янгон' },
  { value: '98', label: '(UTC+07:00) Бангкок, Джакарта, Ханой' },
  { value: '99', label: '(UTC+07:00) Барнаул, Горно-Алтайск' },
  { value: '100', label: '(UTC+07:00) Красноярск' },
  { value: '101', label: '(UTC+07:00) Новосибирск' },
  { value: '102', label: '(UTC+07:00) Томск' },
  { value: '103', label: '(UTC+07:00) Ховд' },
  { value: '104', label: '(UTC+08:00) Гонконг, Пекин, Урумчи, Чунцин' },
  { value: '105', label: '(UTC+08:00) Иркутск' },
  { value: '106', label: '(UTC+08:00) Куала-Лумпур, Сингапур' },
  { value: '107', label: '(UTC+08:00) Перт' },
  { value: '108', label: '(UTC+08:00) Тайбэй' },
  { value: '109', label: '(UTC+08:00) Улан-Батор' },
  { value: '110', label: '(UTC+08:45) Юкла' },
  { value: '111', label: '(UTC+09:00) Осака, Саппоро, Токио' },
  { value: '112', label: '(UTC+09:00) Пхеньян' },
  { value: '113', label: '(UTC+09:00) Сеул' },
  { value: '114', label: '(UTC+09:00) Чита' },
  { value: '115', label: '(UTC+09:00) Якутск' },
  { value: '116', label: '(UTC+09:30) Аделаида' },
  { value: '117', label: '(UTC+09:30) Дарвин' },
  { value: '118', label: '(UTC+10:00) Брисбен' },
  { value: '119', label: '(UTC+10:00) Владивосток' },
  { value: '120', label: '(UTC+10:00) Гуам, Порт-Морсби' },
  { value: '121', label: '(UTC+10:00) Канберра, Мельбурн, Сидней' },
  { value: '122', label: '(UTC+10:00) Хобарт' },
  { value: '123', label: '(UTC+10:30) Лорд-Хау' },
  { value: '124', label: '(UTC+11:00) Магадан' },
  { value: '125', label: '(UTC+11:00) Остров Бугенвиль' },
  { value: '126', label: '(UTC+11:00) Остров Норфолк' },
  { value: '127', label: '(UTC+11:00) Сахалин' },
  { value: '128', label: '(UTC+11:00) Соломоновы о-ва, Нов. Каледония' },
  { value: '129', label: '(UTC+11:00) Чокурдах' },
  { value: '130', label: '(UTC+12:00) Анадырь, Петропавловск-Камчатский' },
  { value: '131', label: '(UTC+12:00) Веллингтон, Окленд' },
  { value: '132', label: '(UTC+12:00) Время в формате UTC +12' },
  { value: '133', label: '(UTC+12:00) Фиджи' },
  { value: '134', label: '(UTC+12:45) Чатем' },
  { value: '135', label: '(UTC+13:00) Время в формате UTC +13' },
  { value: '136', label: '(UTC+13:00) Нукуалофа' },
  { value: '137', label: '(UTC+13:00) Самоа' },
  { value: '138', label: '(UTC+14:00) О-в Киритимати' },
];
